import React from "react";
import Navbar from "../components/navbar";
import MobileNavigation from "../components/hamnavigation";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import API from "../services/API";
import { useState, useEffect } from "react";
import { FaClipboardCheck } from "react-icons/fa";
import "../css/HomeStyles.css";
import "../css/global.css";
import "../css/alert_popup.css";
import "reactjs-popup/dist/index.css";
import translate from "translate";

translate.engine = "google";
translate.key = process.env.DEEPL_KEY;


export default function HomePage() {
  window.onbeforeunload = function () {
    console.log("Your data will be lost!");
  };

  // const { t } = useTranslation();
  const { t} = useTranslation();
  console.log("Value of t:", t);
  const navigate = useNavigate();
  const [data, setData] = useState(
    JSON.parse(localStorage.getItem("homedata")) || {}
  );

  let userJson;
  const [translatedText, setTranslatedText] = useState("");
  const [translatedCompany, setTranslatedCompany] = useState("");
  const [dueInDay, setDueInDay] = useState("");
  const [dueInMonth, setDueInMonth] = useState("");
  const [wish, setWish] = useState("");
  const [collDay, setCollDay] = useState("");
  const [complaint, setComplaint] = useState("");
  const [bill, setBill] = useState("");

  const user = localStorage.getItem("user") || sessionStorage.getItem("user");

  if (user) {
    userJson = JSON.parse(user);
  }

  let agentData = {
    agent_id: userJson.agentId,
  };

  const getHomeData = () => {
    if (userJson) {
      API.agentSummaryAPI(agentData)

        .then((response) => {
          if (response.data.report[0]) {
            setData(response.data.report[0]);
          }

          localStorage.setItem(
            "homedata",
            JSON.stringify(response.data.report[0])
          );

          sessionStorage.setItem(
            "homedata",
            JSON.stringify(response.data.report[0])
          );
        })

        .catch((error) => {
          console.log(error.code);
        });
    }
  };

  window.addEventListener("load", function () {
    window.history.pushState({ noBackExitsApp: true }, "");
  });

  window.addEventListener("popstate", function (event) {
    if (event.state && event.state.noBackExitsApp) {
      window.history.pushState({ noBackExitsApp: true }, "");
    }
  });

  const localstorageValue = localStorage.getItem("i18nextLng") || "en_US";

  useEffect(() => {
    // window.history.pushState({}, "");
    // window.addEventListener("popstate", function (e) {
    //     e.preventDefault();
    //     e.stopPropagation();
    //     window.history.pushState({}, "");
    // });

    getHomeData();
    getLanguage();
  
  
  }, []);

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  const getLanguage = () =>{
    
    const translateText = async () => {
      let translation = "";
      let translationComp="";
      // let translationDay="";
      // let translationMonth="";
      // let translationWish="";
      // let translationCollected = "";
      // let translationComplaint = "";
      // let translationBill = "";
      const originalString = userJson.agentName;
      let convertedName1 = capitalizeFirstLetter(originalString);
      const originalComp = userJson.operatorName;
      let convertedName = capitalizeFirstLetter(originalComp);
      // const originalDay="Total Amount Due On Today";
      // let convertedDay = capitalizeFirstLetter(originalDay);
      // const originalMonth="Amount Collected In This Month";
      // let convertedMonth = capitalizeFirstLetter(originalMonth);
      // const originalWish="Hi";
      // let convertedWish = capitalizeFirstLetter(originalWish);
      // const originalColl="Amount Collected Today";
      // let convertedColl = capitalizeFirstLetter(originalColl);
      // const originalCompl="Number Of Open Complaints";
      // let convertedCompl = capitalizeFirstLetter(originalCompl);
      // const originalBill="Collect Bill";
      // let convertedBill = capitalizeFirstLetter(originalBill);
      
      try {
        if(localstorageValue === "hi_IN"){
          translation = await translate(convertedName1, { from: "en", to: "hi" }); 
          translationComp = await translate(convertedName, { from: "en", to: "hi" });
          // translationDay = await translate(convertedDay, { from: "en", to: "hi" });
          // translationMonth = await translate(convertedMonth, { from: "en", to: "hi" });
          // translationWish = await translate(convertedWish, { from: "en", to: "hi" });
          // translationCollected = await translate(convertedColl, { from: "en", to: "hi" });
          // translationComplaint = await translate(convertedCompl, { from: "en", to: "hi" });
          // translationBill = await translate(convertedBill, { from: "en", to: "hi" });
        }else if(localstorageValue === "kn_IN"){
          translation = await translate(convertedName1, { from: "en", to: "kn" });
          translationComp = await translate(convertedName, { from: "en", to: "kn" });
          // translationDay = await translate(convertedDay, { from: "en", to: "kn" });
          // translationMonth = await translate(convertedMonth, { from: "en", to: "kn" });
          // translationWish = await translate(convertedWish, { from: "en", to: "kn" });
          // translationCollected = await translate(convertedColl, { from: "en", to: "kn" });
          // translationComplaint = await translate(convertedCompl, { from: "en", to: "kn" });
          // translationBill = await translate(convertedBill, { from: "en", to: "kn" });
        }else if(localstorageValue === "ml_IN"){
          translation = await translate(convertedName1, { from: "en", to: "ml" });
          translationComp = await translate(convertedName, { from: "en", to: "ml" });
          // translationDay = await translate(convertedDay, { from: "en", to: "ml" });
          // translationMonth = await translate(convertedMonth, { from: "en", to: "ml" });
          // translationWish = await translate(convertedWish, { from: "en", to: "ml" });
          // translationCollected = await translate(convertedColl, { from: "en", to: "ml" });
          // translationComplaint = await translate(convertedCompl, { from: "en", to: "ml" });
          // translationBill = await translate(convertedBill, { from: "en", to: "ml" });
        }else if(localstorageValue === "ta_IN"){
          translation = await translate(convertedName1, { from: "en", to: "ta" }); 
          translationComp = await translate(convertedName, { from: "en", to: "ta" });
          // translationDay = await translate(convertedDay, { from: "en", to: "ta" });
          // translationMonth = await translate(convertedMonth, { from: "en", to: "ta" });
          // translationWish = await translate(convertedWish, { from: "en", to: "ta" });
          // translationCollected = await translate(convertedColl, { from: "en", to: "ta" });
          // translationComplaint = await translate(convertedCompl, { from: "en", to: "ta" });
          // translationBill = await translate(convertedBill, { from: "en", to: "ta" });
        }else if(localstorageValue === "te_IN"){
          translation = await translate(convertedName1, { from: "en", to: "te" });
          translationComp = await translate(convertedName, { from: "en", to: "te" });
          // translationDay = await translate(convertedDay, { from: "en", to: "te" });
          // translationMonth = await translate(convertedMonth, { from: "en", to: "te" });
          // translationWish = await translate(convertedWish, { from: "en", to: "te" });
          // translationCollected = await translate(convertedColl, { from: "en", to: "te" });
          // translationComplaint = await translate(convertedCompl, { from: "en", to: "te" });
          // translationBill = await translate(convertedBill, { from: "en", to: "te" });
        }else{ 
          translation=userJson.agentName;
          translationComp=userJson.operatorName;
          // translationDay = "Total Amount Due as on Today";
          // translationMonth = "Amount Collected in this Month";
          // translationWish = "Hi";
          // translationCollected = "Amount Collected Today";
          // translationComplaint = "Number of Open Complaints";
          // translationBill = "Collect Bill";
        }
         
      } catch (error) {
        console.error("Translation error:", error);
      }
      setTranslatedText(translation); 
      setTranslatedCompany(translationComp);
      // setDueInDay(translationDay);
      // setDueInMonth(translationMonth);
      // setWish(translationWish);
      // setCollDay(translationCollected);
      // setComplaint(translationComplaint);
      // setBill(translationBill);
    };
    translateText();
   
  }


 

  return (
    <>
      <div className="container">
        <div>
          <div className="headerblue">
            <MobileNavigation />
            <p className="Company_name">
              {userJson ? translatedCompany : null}
            </p>

            <div className="profile-img-div">
              <img
                src={require("../assets/profile1.png")}
                className="profile_img"
                alt=""
              />
            </div>
          </div>
          <p className="user_name">
            {t("HO_lbl_wish")} {userJson ? translatedText : null}
          </p>

          {/* <div className="amt-due-today-div-temp" style={{ height: '{{t("HO_lbl_Unpaid")}.length*20}px'}}> */}
          <div class="amt-due-today-div-temp" style={{height: `${(t("HO_lbl_Unpaid").length*3)}px`}}>
          {/* <div class="amt-due-today-div-temp" style={{height: "max-content"}}> */}

            <label
              className="amt-due-today-content"
              onClick={() => navigate("/customer")}
            >
              {t("HO_lbl_Unpaid")}
            </label>
            <label className="amt-due-today-content">
              ₹{data.pending_amount}
            </label>
          </div>

          <div
            className="amt-collected-month-div-temp"
            onClick={() => navigate("/monthlyreport")}
            style={{height: `${(t("HO_lbl_Unpaid").length*3)}px`}}
          >
            <label className="amt-collected-month-content">
              {t("HO_lbl_Collected")}
            </label>
            <label className="amt-collected-month-content">
              ₹{data.collected_amount}
            </label>
          </div>

          <div
            className="amt-collected-today-div-temp"
            onClick={() => navigate("/dailyReport")}
            style={{height: `${(t("HO_lbl_Unpaid").length*3)}px`}}
          >
            <label className="amt-collected-today-content">
              {t("HO_lbl_Daily")}
            </label>
            <label className="amt-collected-today-content">
              ₹{data.daily_collection_amount}
            </label>
          </div>

          <div className="complaints-div-temp"  style={{height: `${(t("HO_lbl_Unpaid").length*3)}px`}}>
            <label className="complaints-content">
              {t("HO_lbl_Complaints")}
            </label>
            <label className="complaints-content">
               {data.no_of_complaints}
            </label>
          </div>

          <div className="collect-btn-div">
            <button className="collectBtn" type="submit" onClick={() => navigate("/customer")}
              style={{ display: "flex",justifyContent: "center",alignContent: "center",flexDirection: "row",gap: "10px",width: "85%"}}>
              <FaClipboardCheck />
              {t("HO_button_Collect_Bill")}
            </button>
          </div>
        </div>
      </div>

      <Navbar
        value={0}
        // onChange={() => {
        //   window.location.reload();
        // }}
      />
    </>
  );
}
